<script setup lang="ts">
import { theme as antTheme } from 'ant-design-vue'
import { computed } from 'vue'
import AppShell from '@/layouts/AppShell.vue'
import { useThemeStore } from '@/stores/themeStore.js'

const themeStore = useThemeStore()
const themeConfig = computed(() => ({
  algorithm: themeStore.resolved === 'dark' ? antTheme.darkAlgorithm : antTheme.defaultAlgorithm,
  token: {
    colorPrimary: '#315c4f',
    colorInfo: '#315c4f',
    borderRadius: 8,
    fontFamily:
      'Inter, "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", system-ui, sans-serif',
  },
}))
</script>

<template>
  <a-config-provider :theme="themeConfig">
    <AppShell />
  </a-config-provider>
</template>
